module.exports = __webpack_public_path__ + "img/gongtongfuyu.360d72e4.png";